import React from 'react';
import { Animate } from "react-simple-animate";

export default function MediaFooter({className, gap}) {
    return (

        <>
        
        <div className={className}>
        <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
            <div className="mediaFooterIconsContainer flex flex-row gap-10 sm:gap-4 items-center  ">
                <img alt={"facebook logo"} className="mediaFooterIcon_1 cursor-pointer" src="https://www.kipmate.com/sortyourkip/client/build/facebook_logo.svg" />
                <img alt={"linkedin logo"} className="mediaFooterIcon_2 cursor-pointer" src="https://www.kipmate.com/sortyourkip/client/build/linkedin_logo.svg" />
                <img alt={"twitter logo"} className="mediaFooterIcon_3 cursor-pointer" src="https://www.kipmate.com/sortyourkip/client/build/twitter_logo.svg" />
                <img alt={"instagram logo"} className="mediaFooterIcon_4 cursor-pointer" src="https://www.kipmate.com/sortyourkip/client/build/instagram_logo.svg" />
                <img alt={"tiktok logo"} className="mediaFooterIcon_5 cursor-pointer" src="https://www.kipmate.com/sortyourkip/client/build/tiktok_logo.svg" />
            </div>
            </Animate>
        </div>
        
        </>

    );
}
